import { Stack, Text } from '@chakra-ui/react';
import { getTranslations } from 'next-intl/server';

import { AppRoutes } from '@/constants/route';
import { NextLinkButton } from '@/modules/navigation/presentation';

export const RegisterPrompt = async () => {
	const t = await getTranslations('authentication.login.registerPrompt');

	return (
		<Stack gap="sm">
			<Text textStyle="h3">
				{t('title')}
			</Text>
			<Stack bg="#F8F8F8" borderRadius="lg" gap="md" p="sm">
				<Stack gap="2xs">
					<Text color="tertiary.120" textStyle="bodyBold">
						{t('headline')}
					</Text>
					<Text textStyle="body" whiteSpace="pre-wrap">
						{t('body')}
					</Text>
				</Stack>
				<NextLinkButton colorPalette="tertiary" href={AppRoutes.auth.register} size="lg">
					{t('cta.label')}
				</NextLinkButton>
				<Stack gap="2xs">
					<Text textStyle="h4">
						{t('benefits.title')}
					</Text>
					<Text textStyle="body">
						{t('benefits.description')}
					</Text>
				</Stack>
			</Stack>
		</Stack>
	);
};
